__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/6534c6689b6eff9c6166dec62c6906f4d6682cec6b49c79c3caa0a9f/";